import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";
import type { UserRowType } from "../../../pages/conversation_center/components/Table/Table.decl";

export function getUser(agents: CallConversation["agents"]): UserRowType[] {
  return agents.flatMap((agent) => {
    if (agent?.teammate.entity.__typename !== "PhoneTeammate") {
      return [];
    }

    const id = Number(agent.teammate.entity.ID);
    const { fullName } = agent.teammate.entity;

    return [{ id, fullName }];
  });
}
